module.exports = __webpack_public_path__ + "cancellara-dist/img/assistenza.2c159fec.png";